import { isNil } from '@lucidlink/tscore';
export var LogLevel;
(function (LogLevel) {
    LogLevel["TRACE"] = "trace";
    LogLevel["DEBUG"] = "debug";
    LogLevel["INFO"] = "info";
    LogLevel["WARNING"] = "warn";
    LogLevel["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
// due to a bug in pino.Logger.isLevelEnabled (for browser environment), we need our own implementation
export function isLevelEnabled(desiredLevel, logger) {
    const configuredLevelNumeric = logger.levelVal;
    const desiredLevelNumeric = logger.levels.values[desiredLevel];
    return isNil(desiredLevelNumeric) ? false : desiredLevelNumeric >= configuredLevelNumeric;
}
export class LogConfig {
    logLevel = LogLevel.INFO;
    pretty = false;
    colorize = false;
    filePath = undefined;
    sync = true;
}
export const PrettyConsoleLogger = {
    logLevel: LogLevel.INFO,
    pretty: true,
    colorize: false,
    filePath: undefined,
    sync: true,
};
export const JsonConsoleLogger = {
    logLevel: LogLevel.INFO,
    pretty: false,
    colorize: false,
    filePath: undefined,
    sync: true,
};
export const PrettyFileLogger = {
    logLevel: LogLevel.INFO,
    pretty: true,
    colorize: false,
    filePath: 'WebFs.log',
    sync: true,
};
export const JsonFileLogger = {
    logLevel: LogLevel.INFO,
    pretty: false,
    colorize: false,
    filePath: 'WebFs.log',
    sync: true,
};
